import BrainstormIdeasEditTemplate from "../../Templates/BrainstormIdeasEdit";

export default function BrainstormIdeasEditPage() {
    return (
        <BrainstormIdeasEditTemplate />
    )
}

